import React from 'react';
import { Container, Typography, Breadcrumbs, Divider } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { withTranslation, useTranslation } from 'react-i18next';

const RegisterConfirm = () => {
    const { t, i18n } = useTranslation();
    return (
        <Container>

            <Breadcrumbs style={{ marginTop: 20 }}>
                <Typography color="textPrimary">{t("RegisterConfirm")}</Typography>
            </Breadcrumbs>
            <Divider style={{ marginTop: 10, marginBottom: 10 }} />

            <Alert style={{ marginTop: 10 }} severity="success">{t("RegisterConfirmSubtitle")}</Alert>
        </Container>
    );
}

export default RegisterConfirm;